import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import jsPDF from "jspdf";


@Component({
	selector: "app-crm-pie-charts",
	templateUrl: "./crm_pie_charts.component.html",
	styleUrls: ["./crm_pie_charts.component.css"],
})
export class CrmPieChartComponent implements OnInit, OnChanges {
	@Input() dataSource: { [key: string]: any }[] = [];
	@Input() campi = []
	@Input() proceduraSelected
	@Input() moduloSelected
	@Input() anniSelected
	esportSetting = [
		{ value: "SVG", name: "SVG", icon: "globe" },
		{ value: "JPEG", name: "JPEG", icon: "image" },
		{ value: "PDF", name: "PDF", icon: "pdffile" },
	];
	loading: boolean = false

	constructor() { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['dataSource'] && changes['dataSource'].currentValue) {
			this.loading = true
			/* 			console.log('cambio dataSource')
						console.log(changes['dataSource'].currentValue) */
			this.processaDati().then(() => {
				this.loading = false
			})
		}
		/* 		if (changes['proceduraSelected'] && changes['proceduraSelected'].currentValue) {
					console.log(changes)
				}
				if (changes['moduloSelected'] && changes['moduloSelected'].currentValue) {
					console.log(changes)
				}
				if (changes['anniSelected'] && changes['anniSelected'].currentValue) {
					console.log(changes)
				} */

	}

	ngOnInit(): void {

	}

	customizeLabel(event) {
		//console.log(event)
		if (event.point.data[parseInt(event.seriesName)] > 0)
			return `${event.point.data.desMese}: ${event.point.data[parseInt(event.seriesName)]}`
	}

	legendClick(event): void {
		const arg = event.target;
		const item = event.component.getAllSeries()[0].getPointsByArg(arg)[0];
		if (item.isVisible()) {
			return item.hide();
		} else {
			return item.show();
		}
	}

	onItemClick(event: any, element: HTMLElement) {
		console.log(element)
		const arrayClass: string[] = Object.values(event.element.classList)
		if (arrayClass.includes('printBtn')) {
			const svgString = new XMLSerializer().serializeToString(element.querySelector('svg'));
			this.stampaCustom(svgString, this.creaDettagliStampa(element.querySelector('dx-pie-chart').getAttribute('ng-reflect-title')), this.creaTitoloStampa())
		}
		if (arrayClass.includes('esportBtn')) {
			const typeExport = event.itemData
			if (typeExport) {
				this.scaricaCustom(element.querySelector('svg'), typeExport.value, this.creaTitoloStampa(), this.creaDettagliStampa(element.querySelector('dx-pie-chart').getAttribute('ng-reflect-title'), false))
			}
		}
	}

	creaTitoloStampa() {
		let titolo = 'Statistiche Procedure e Moduli'
		return `${titolo}`
	}
	creaDettagliStampa(titoloPie: string, isStampa = true) {
		let filtro = ''
		let value = titoloPie.split(' ').filter(x => !isNaN(parseInt(x)))
		if (this.moduloSelected !== null || this.proceduraSelected !== null) {
			if (isStampa) filtro += '<h3>Dettagli Filtri</h3>'
			filtro += '<ul>'
			if (this.moduloSelected === null) {
				filtro += `<li><strong>Procedura:</strong> ${this.proceduraSelected}</li>`;
			} else if (this.proceduraSelected === null) {
				filtro += `<li><strong>Modulo:</strong> ${this.moduloSelected}</li>`;
			} else {
				filtro += `
				<li><strong>Procedura:</strong> ${this.proceduraSelected}</li>
				<li><strong>Modulo:</strong> ${this.moduloSelected}</li>
				`;
			}
			filtro += '</ul>'
		}
		if (value) {
			let dati = this.dataSource.map((dato) => {
				return {
					mese: dato.desMese,
					value: dato[value[0]],
				}
			})
			if (dati && dati.length > 0) {

				if (isStampa) filtro += '<h3>Dettagli dati</h3>'
				filtro += '<ul>'
				dati.forEach((x) => {
					filtro += `<li><strong>${x.mese}:</strong> ${x.value}</li>`;
				})
				filtro += '</ul>'
			}
		}
		if (filtro !== '') {
			return filtro
		} else {
			return ''
		}
	}
	creaDettagliScarica(titoloPie: string) {
		let filtro = []
		let value = titoloPie.split(' ').filter(x => !isNaN(parseInt(x)))
		if (value) {
			let dati = this.dataSource.map((dato) => {
				return {
					mese: dato.desMese,
					value: dato[value[0]],
				}
			})
			if (dati && dati.length > 0) {

				dati.forEach(dato => {
					filtro.push(`${dato.mese}: ${dato.value}`)
				});
			}
		}

		if (filtro.length > 0) {
			return filtro
		} else {
			return []
		}
	}
	creaDettagliFiltro() {
		let filtro = []
		if (this.moduloSelected !== null || this.proceduraSelected !== null) {
			filtro.push(``)
			if (this.moduloSelected === null) {
				filtro.push(`Procedura: ${this.proceduraSelected}`)
			} else if (this.proceduraSelected === null) {
				filtro.push(`Modulo: ${this.moduloSelected}`)
			} else {
				filtro.push(`Procedura: ${this.proceduraSelected}`)
				filtro.push(`Modulo: ${this.moduloSelected}`)
			}
			filtro.push(``)
		}

		if (filtro.length > 0) {
			return filtro
		} else {
			return []
		}
	}
	customizeTooltip(event) {
		//console.log(event)
		const data = event.point.data;
		const datiAssociati = data.datiAssociati;
		const anni = datiAssociati ? Object.keys(datiAssociati).filter((x) => { return parseInt(x) === parseInt(event.seriesName) }) : null;
		const totale = event.valueText;
		const percent = event.percentText;
		const mese = event.argumentText
		if (anni !== null) {
			const result = anni.map(anno => {
				const rawDati = datiAssociati[anno] || [];
				const grouped = new Map();
				rawDati.forEach(item => {
					const sigla = item.m_isModulo === null ? item.Sigla : item.m_Sigla;
					const nome = item.m_isModulo === null ? item.Des : item.m_Des;
					const isModulo = item.m_isModulo === null ? item.isModulo : item.m_isModulo;
					if (!grouped.has(sigla)) {
						grouped.set(sigla, {
							anno: anno,
							nome: nome,
							sigla: sigla,
							isModulo: isModulo,
							count: 1,
						});
					} else {
						const entry = grouped.get(sigla);
						entry.count += 1;
					}
				});

				const dettagli = Array.from(grouped.values()).map(entry => ({
					anno: entry.anno,
					nome: entry.nome,
					sigla: entry.sigla,
					isModulo: entry.isModulo,
					count: entry.count,
				}));
				return { dettagli, totale, percent, mese };
			});
			//console.log(result)
			return result[0];
		} else {
			return { dettagli: [], totale, percent, mese };
		}

	}
	onExporting(event) {
		//console.log(event)
		const name = event.component.series[0].name
		//this.consoleLog(name)
		event.fileName = `stat_procedure_${name}_torta`
		event.cancel = true
	}
	onFileSaving(event) {
		//console.log(event)
	}
	async processaDati() {
		const campiDaRimuovere = new Set();//new Set costruisce un oggetto iterabile
		this.campi.forEach(campo => {
			if (this.dataSource.every(dato => dato[campo.value] === 0)) { //every() controlla che tutti gli elementi di un array soddisfano una condizione 
				campiDaRimuovere.add(campo.value);//add() aggiunge il risultato al set da iterare
			}
		});
		this.campi = this.campi.filter(campo => !campiDaRimuovere.has(campo.value));//has() controlla se un set ha un valore 
		this.dataSource = this.dataSource.map(dato => {
			let nuovoDato = {};
			Object.keys(dato).forEach(chiave => {
				if (!campiDaRimuovere.has(chiave)) {
					nuovoDato[chiave] = dato[chiave];
				}
			});
			return nuovoDato;
		});
		/* 		console.log(this.dataSource)
				console.log(this.campi) */
	}

	private stampaCustom(svgString, innerHtml = '', titolo = '') {
		const blobMain = new Blob([svgString], { type: "image/svg+xml" });
		const urlMain = URL.createObjectURL(blobMain);
		const iframe = document.createElement("iframe");
		iframe.style.position = "absolute";
		iframe.style.width = "0px";
		iframe.style.height = "0px";
		iframe.style.border = "none";
		document.body.appendChild(iframe);
		const doc = iframe.contentWindow.document;
		doc.open();
		doc.write(`
			<html>
					<head>
							<title></title>
							<style>
                    @page {
                        size: portrait; /* portrait o landscape */
                        margin: 3mm; 
                    }		
										.chartContent{
											display: flex;
											flex-direction: row;
											align-items: center;
											justify-content: center;
											gap: 12px;
										}
										.titolo{
										margin-left:auto;
										margin-right:auto;
										}
                </style>
					</head>
					<body>
							<div class="container">
								<h1 class="titolo">${titolo}</h1>
								<div class="chartContent"><img class="img" src="${urlMain}" /></div>
								${innerHtml}
							</div>
							<script>
									window.onload = function() {
											window.print();
											setTimeout(() => {
													window.parent.document.body.removeChild(window.frameElement);
											}, 1000);
									};
							</script>
					</body>
			</html>
	`);
		doc.close();
	}

	scaricaCustom(svgElement, formato, titolo = '', innerHtml = '') {

		// Clonare l'SVG per modificarlo senza alterare l'originale
		const svgClone = svgElement.cloneNode(true);
		// Convertire l'SVG in stringa
		const svgString = new XMLSerializer().serializeToString(svgClone);

		// Se il formato richiesto è SVG, scaricare direttamente il file
		if (formato.toLowerCase() === "svg") {
			const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
			const downloadUrl = URL.createObjectURL(svgBlob);
			const link = document.createElement("a");
			link.href = downloadUrl;
			link.download = `stat_procedure_pie_${new Date().toLocaleString("it-IT", {
				day: "2-digit",
				month: "numeric",
				year: "numeric",
			})}.svg`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(downloadUrl);
			return; // Uscita dalla funzione
		} else if (formato.toLowerCase() === "pdf") {
			return this.scaricaPdf(svgElement, titolo, innerHtml)
		} else {
			// Creare un oggetto immagine dal blob SVG
			const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
			const url = URL.createObjectURL(svgBlob);
			const img = new Image();

			img.onload = function () {
				// Creare un canvas per la conversione
				const canvas = document.createElement("canvas");
				const ctx = canvas.getContext("2d");

				// Impostare le dimensioni del canvas (si può adattare in base alle esigenze)
				canvas.width = img.width || 1000;
				canvas.height = img.height || 1000;

				// Disegnare l'immagine sul canva
				ctx.fillStyle = "white";
				ctx.fillRect(0, 0, canvas.width, canvas.height);
				ctx.drawImage(img, 0, 0);


				// Gestire gli altri formati
				let mimeType = "image/png"; // default
				if (formato.toLowerCase() === "jpg" || formato.toLowerCase() === "jpeg") {
					mimeType = "image/jpeg";
				} else if (formato.toLowerCase() === "pdf") {
					mimeType = "image/pdf";
				}

				canvas.toBlob((blob) => {
					// Creare un URL per il Blob e simulare il download
					const downloadUrl = URL.createObjectURL(blob);
					const link = document.createElement("a");
					link.href = downloadUrl;
					link.download = `stat_procedure_pie_${new Date().toLocaleString("it-IT", {
						day: "2-digit",
						month: "numeric",
						year: "numeric",
					})}.${formato.toLowerCase()}`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					URL.revokeObjectURL(downloadUrl);
				}, mimeType);
			}
			// Iniziare il caricamento dell'immagine
			img.src = url;
		}

	}

	scaricaPdf(svgElement, titolo, innerHtml = '') {
		// Clonare l'SVG per modificarlo senza alterare l'originale
		const svgClone = svgElement.cloneNode(true);
		// Convertire l'SVG in stringa
		const svgString = new XMLSerializer().serializeToString(svgClone);

		// Creare un oggetto immagine dal blob SVG
		const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
		const url = URL.createObjectURL(svgBlob);
		const img = new Image();

		// Creare un contenitore HTML per la struttura del PDF
		const container = document.createElement('div');

		container.style.width = '2000px';
		container.style.height = '3000px';
		container.style.display = 'flex'
		container.style.flexDirection = 'column'
		container.style.justifyItems = 'center'
		container.style.justifyContent = 'top'
		container.style.fontFamily = "Arial, sans-serif";
		container.innerHTML += `
		<h1 style="text-align:center; font-size:110px">${titolo}</h1>
    `;
		container.innerHTML += '<div id="chartCont" style="margin-right:auto;margin-left:auto;margin-bottom:30px;"></div>'
		if (innerHtml !== '') container.innerHTML += `<h1 style="font-size:56px">Dettagli Dati</h1>`
		container.innerHTML += `<div style="font-size:50px">${innerHtml}</div>`
		console.log(container)

		img.onload = function () {
			// Creare un canvas con queste dimensioni
			const canvas = document.createElement("canvas");
			canvas.width = 1200;
			canvas.height = 1200;
			const ctx = canvas.getContext("2d");

			ctx.fillStyle = "white";
			ctx.fillRect(0, 0, canvas.width, canvas.height);

			// Mantieni le proporzioni ridimensionando l'immagine
			ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
			const tmp = container.querySelector('#chartCont').appendChild(canvas)
			tmp.style.height = '1600px';
			tmp.style.width = '1600px';
			tmp.style.marginLeft = 'auto'
			tmp.style.marginRight = 'auto'
			// Usa il metodo html() per convertire il contenitore in PDF
			new jsPDF({
				orientation: 'portrait',
				unit: 'px',
				format: 'a4'
			}).html(container, {
				callback: function (pdf) {
					// Salva il PDF una volta completata la conversione
					pdf.save(`stat_procedure_pie_${new Date().toLocaleString("it-IT", {
						day: "2-digit",
						month: "numeric",
						year: "numeric"
					})}.pdf`);
				},
				x: 0,    // coordinata x di partenza
				y: 0,    // coordinata y di partenza
				margin: [20, 20, 9, 20],
				html2canvas: {
					scale: 0.2
				}
			});

			// Liberare la memoria dell'URL creato per il blob SVG
			URL.revokeObjectURL(url);
		};

		// Iniziare il caricamento dell'immagine
		img.src = url;
		return
	}

}
